<template>
  <v-footer color="#0A1B34" class="site-footer">
    <v-container>
      <v-row>
        <v-col cols="12" md="4">
          <div class="site-footer__brand">
            <v-img class="site-footer__logo" contain :src="require('@/assets/Navbar/256.png')" alt="Mayon Clinical Laboratory" />
            <div>
              <h3>Mayon Clinical Laboratory</h3>
              <p>Accurate, reliable, and affordable diagnostic healthcare services in Quezon City.</p>
            </div>
          </div>
          <div class="site-footer__socials">
            <a href="https://www.facebook.com/MayonLab" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
              <v-img alt="Facebook" contain :src="require('@/assets/icons/icons8-facebook-96.svg')" />
            </a>
            <a href="https://www.instagram.com/mayonlab/" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
              <v-img alt="Instagram" contain :src="require('@/assets/icons/icons8-instagram-96.svg')" />
            </a>
          </div>
        </v-col>

        <v-col cols="12" sm="6" md="2">
          <h4>Quick links</h4>
          <router-link v-for="item in footerLinks" :key="item.label" :to="footerTo(item)">
            {{ item.label }}
          </router-link>
          <a :href="portalLink.url" target="_blank" rel="noopener noreferrer">{{ portalLink.label }}</a>
        </v-col>

        <v-col cols="12" sm="6" md="3">
          <h4>Branches</h4>
          <div v-for="branch in branches" :key="branch.id" class="site-footer__branch">
            <router-link :to="`/branches/${branch.id}`"><strong>{{ branch.name }}</strong></router-link>
            <span>{{ branch.address }}</span>
            <a :href="branch.phoneHref">{{ branch.phone }}</a>
          </div>
        </v-col>

        <v-col cols="12" md="3">
          <h4>Contact</h4>
          <a href="mailto:mayonlab18@gmail.com">mayonlab18@gmail.com</a>
          <a href="mailto:mayonlabmplace@gmail.com">mayonlabmplace@gmail.com</a>
          <a :href="contactChannels.mainPhoneHref">{{ contactChannels.mainPhoneDisplay }}</a>
          <p class="site-footer__hours">Main: Mon–Sat & holidays 6:00 AM–5:00 PM; Sunday 6:00 AM–12:00 NN.<br />M Place: Mon–Sun & holidays 6:00 AM–5:00 PM.</p>
        </v-col>
      </v-row>

      <div class="site-footer__bottom">
        <span>© {{ currentYear }} Mayon Clinical Laboratory. All rights reserved.</span>
        <span>Prices and service availability should be confirmed before visiting.</span>
      </div>
    </v-container>
  </v-footer>
</template>

<script>
import { branches, contactChannels, portalLink } from '@/data/mayonSite'

export default {
  name: 'FooterView',
  data() {
    return {
      branches,
      contactChannels,
      footerLinks: [
        { label: 'Home', path: '/' },
        { label: 'Packages', path: '/packages' },
        { label: 'Services', path: '/services' },
        { label: 'HMO Partners', path: '/hmo-partners' },
        { label: 'Branches', path: '/branches' },
        { label: 'About', path: '/about' }
      ],
      portalLink
    }
  },
  computed: {
    currentYear() {
      return new Date().getFullYear()
    }
  },
  methods: {
    footerTo(item) {
      return item.path
    }
  }
}
</script>

<style lang="scss" scoped>
.site-footer {
  color: #ffffff;
  padding: 4rem 0 1.5rem;

  h3,
  h4 {
    color: #ffffff;
    font-weight: 900;
  }

  h4 {
    font-size: 1rem;
    margin-bottom: 1rem;
  }

  p,
  span,
  a,
  button {
    color: rgba(255, 255, 255, 0.76);
    line-height: 1.7;
  }

  a,
  button {
    background: transparent;
    border: 0;
    cursor: pointer;
    display: block;
    font-size: 0.95rem;
    padding: 0.15rem 0;
    text-align: left;
    text-decoration: none;
    transition: color 0.18s ease;

    &:hover {
      color: var(--mayon-teal);
    }
  }

  &__brand {
    align-items: flex-start;
    display: flex;
    gap: 1rem;
  }

  &__logo {
    flex: 0 0 58px;
    height: 58px;
    width: 58px;
  }

  &__socials {
    display: flex;
    gap: 0.65rem;
    margin-top: 1rem;

    a {
      align-items: center;
      background: rgba(255, 255, 255, 0.08);
      border: 1px solid rgba(255, 255, 255, 0.10);
      border-radius: 999px;
      display: inline-flex;
      height: 42px;
      justify-content: center;
      transition: background 0.18s ease, border-color 0.18s ease, transform 0.18s ease;
      width: 42px;

      &:hover {
        background: rgba(88, 184, 184, 0.14);
        border-color: rgba(88, 184, 184, 0.28);
        transform: translateY(-1px);
      }
    }

    .v-image {
      height: 26px;
      width: 26px;
    }
  }

  &__branch {
    margin-bottom: 1rem;

    strong,
    span,
    a {
      display: block;
    }

    strong {
      color: #ffffff;
      margin-bottom: 0.25rem;
    }
  }

  &__hours {
    margin-top: 1rem;
  }

  &__bottom {
    border-top: 1px solid rgba(255, 255, 255, 0.14);
    display: flex;
    flex-wrap: wrap;
    gap: 0.75rem;
    justify-content: space-between;
    margin-top: 2.5rem;
    padding-top: 1.25rem;
  }
}
</style>
